export default __webpack_public_path__ + "fcdb30b.png";